
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { auth } from '@/includes/firebase';
import Modal from './Modal.vue';

export default defineComponent({
  name: 'Navbar',
  components: {
    Modal,
  },
  computed: {
    ...mapState(['userLoggedIn']),
    userDisplayName: () => {
      return auth.currentUser?.displayName?.split(' ')[0];
    },
  },
  methods: {
    async signOut() {
      await this.$store.dispatch('signOut');
      window.location.reload();
    },
    handleBack() {
      this.$router.back();
    },
    handleForward() {
      this.$router.forward();
    },
  },
});
